<table class="table table-sm mb-0">
    <thead class="sticky-header">
    <tr>
        <th>Måned</th>
        <th *ngFor="let user of caseUsers" class="text-center text-wrap w-6rem">
            <span class="d-block fw-normal">{{ user.navn ?? 'Ukendt' }}</span>
            <span *ngIf="user.cardId !== null && user.cardId === la" class="badge bg-light text-dark my-auto ms-1">LA</span>
            <span *ngIf="user.cardId !== null && user.cardId === ka" class="badge bg-light text-dark my-auto ms-1">KA</span>
            <span *ngIf="user.cardId !== null && user.cardId === sag?.sa" class="badge bg-light text-dark my-auto ms-1">SA</span>
        </th>
        <th class="text-end w-6rem">Total</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let month of caseMonths; trackBy:trackByMonthAndYear">
        <td>{{ month | date:'MMMM yyyy' }}</td>
        <td *ngFor="let user of caseUsers; trackBy:trackByUserId" class="text-end">
            <app-resourceplan-timer-input
                    [timer]="resourceplanTableHelper.getUserTimeBudgetByMonth(timeBudgets, user.cardId, month)"
                    [disabled]="sag.locked"
                    (saveTimer)="saveTimer($event, month, user)"
            ></app-resourceplan-timer-input>
        </td>
        <td class="pe-2 text-end">{{ resourceplanTableHelper.getTotalTimerByMonth(timeBudgets, month) | time }}</td>
    </tr>
    </tbody>
    <tfoot class="sticky-footer">
    <tr>
        <td>Timer i alt</td>
        <td *ngFor="let user of caseUsers; trackBy:trackByUserId" class="text-end">
            {{ resourceplanTableHelper.getTotalTimerByUser(timeBudgets, user.cardId) | time }}
        </td>
        <td class="pe-2 text-end">
            {{ totalTimer | time }}
        </td>
    </tr>
    <tr>
        <td>Honorar i alt</td>
        <td *ngFor="let user of caseUsers; trackBy:trackByUserId" class="text-end">
            {{ resourceplanTableHelper.getTotalHonorarByUser(timeBudgets, user.cardId) | currency:'DKK':'':'1.2-2':'da' }}
        </td>
        <td class="pe-2 text-end">
            {{ totalHonorar | currency:'DKK':'':'1.2-2':'da' }}
        </td>
    </tr>
    <tr>
        <td>Prisjustering</td>
        <td *ngFor="let user of caseUsers; trackBy:trackByUserId" class="text-end"></td>
        <td class="text-end">
            <input
                #prisjusteringInput
                (change)="savePrisjustering(prisjusteringInput.value)"
                [value]="sag?.prisjustering | currency:'DKK':'':'1.2-2':'da'"
                type="text"
                class="text-end form-control form-control-sm pris-input"/>
        </td>
    </tr>
    <tr class="fw-bold">
        <td>Total</td>
        <td *ngFor="let user of caseUsers; trackBy:trackByUserId" class="text-end"></td>
        <td class="pe-2 text-end">
            {{ totalHonorar + sag?.prisjustering | currency:'DKK':'':'1.2-2':'da' }}
        </td>
    </tr>
    <tr *ngIf="timerOutsidePeriod">
        <td colspan="100" class="text-center text-danger">Der er planlagte timer udenfor den valgte
            udførselsperiode!
        </td>
    </tr>
    </tfoot>
</table>
